import {useEffect, useState} from "react";
import {
    calculateAsOfDate,
} from "../../../../helpers/utils/OrderDetailUtils";

import {
    useLazyGetJurisdictionByTaxListQuery,
    useLazyGetJurisdictionsNextMonthDuesQuery
} from "../../../data/jurisdiction/jurisdictionApi";
import {
    jurisdictionRowFormatting,
    NationalJurisdictionHeader,
    nationalJurisdictionYearFields,
    nationalSelectDropdownField
} from "../TaxCertificate/TaxCertNationalUtil";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import {showToast} from "../../../../helpers/utils/Utils";
import DateInputField from "../DateInputField";
import NationalJurisdictionPickerModal from "../../modal/NationalJurisdictionPickerModal";
import NationalJurisdictionListModal from "../../modal/NationalJurisdictionListModal";

interface JurisdictionSectionProps {
    curAccount: any;
    setShowAccount: any
    accounts: any[];
    setAccounts: any;
    setIsSavedResult: (isSaved: boolean) => void;
    autoCalculate: boolean;
    setAutoCalculate: any;
    certificate: any;
    setCertificate: (certificate: any) => void;
    showAccount: number;
    jurisdictionId: number;
    setJurisdictionId: (id: number) => void;
    removeJurisdiction: boolean;
    setRemoveJurisdiction: (remove: boolean) => void;
    setIsAddNewSummaryRow: (add: boolean) => void;
    setTaxYear: (year: string) => void;
    clearJurisRow: boolean;
    setClearJurisRow: (clear: boolean) => void;
    setUpdateTotalTaxValue: (update: boolean) => void;
    editable: boolean;
    county: string;
    orderId: any;
    setRender: any;
    primaryCollector: any;
    updatedAccountIndexList:any;
    setUpdatedAccountIndexList?: any;
}

export function JurisdictionSection({
                                        curAccount,
                                        setShowAccount,
                                        accounts,
                                        setAccounts,
                                        setIsSavedResult,
                                        autoCalculate,
                                        setAutoCalculate,
                                        certificate,
                                        setCertificate,
                                        showAccount,
                                        jurisdictionId,
                                        setJurisdictionId,
                                        removeJurisdiction,
                                        setRemoveJurisdiction,
                                        setIsAddNewSummaryRow,
                                        setTaxYear,
                                        clearJurisRow,
                                        setClearJurisRow,
                                        setUpdateTotalTaxValue,
                                        editable,
                                        county,
                                        orderId,
                                        setRender,
                                        primaryCollector,
                                        updatedAccountIndexList,
                                        setUpdatedAccountIndexList
                                    }: JurisdictionSectionProps) {

    const [isTaxSummaryReset, setIsTaxSummaryReset] = useState(false);
    const [showJurisdictionModal, setShowJurisdictionModal] = useState(false);
    const [reloadJurisdictionSection, setShowReloadJurisdictionSection] = useState(false);
    const [showJurisdictionPickerModal, setShowJurisdictionPickerModal] = useState(false);
    const [reloadJurisdictionList, setReloadJurisdictionList] = useState(false);
    const [reloadJurisdictionNextMonthDue, setReloadJurisdictionNextMonthDue] = useState(false);
    const [type, setType] = useState("");
    const [taxRateList, taxRateListApi] = useLazyGetJurisdictionByTaxListQuery();
    const [jurisdictionsNextMonthApi, jurisdictionsNextMonthApiResponse] = useLazyGetJurisdictionsNextMonthDuesQuery();
    const {data: enums} = useGetEnumsQuery("");

    useEffect(() => {
        if (!taxRateListApi?.data || !certificate.accounts[showAccount]?.jurisdictionList) return;

        const updatedCertificate = {...certificate};
        const updatedJurisdictions = updatedCertificate.accounts[showAccount].jurisdictionList.map((jurisdiction: any) => {
            const match = taxRateListApi.data?.taxRateList.find(
                (p: any) => p.jurisdictionId === jurisdiction.jurisdictionId && p.year === parseInt(jurisdiction.taxYear, 10)
            );

            return match ? {...jurisdiction, tax_rate: match.rate} : jurisdiction;
        });

        updatedCertificate.accounts = [...updatedCertificate.accounts];
        updatedCertificate.accounts[showAccount] = {
            ...updatedCertificate.accounts[showAccount],
            jurisdictionList: updatedJurisdictions,
        };

        setCertificate(updatedCertificate);
        setIsSavedResult(false);

        setUpdateTotalTaxValue(true);
    }, [taxRateListApi]);


    useEffect(() => {
        if (!jurisdictionsNextMonthApiResponse?.data || !certificate.accounts[showAccount]?.jurisdictionList) return;

        const updatedCertificate = {...certificate};
        const updatedJurisdictionList = updatedCertificate.accounts[showAccount].jurisdictionList.map((jurisdiction: any) => {
            const match = jurisdictionsNextMonthApiResponse?.data?.jurisdictions.find(
                (p: any) =>
                    p.jurisdictionId === jurisdiction.jurisdictionId &&
                    parseInt(p.taxYear, 10) === parseInt(jurisdiction.taxYear, 10) &&
                    parseInt(p.baseTaxDue, 10) === parseInt(jurisdiction.baseDue, 10)
            );

            return match ? {...jurisdiction, nextMonthTaxDue: match.nextMonthTaxDue} : jurisdiction;
        });

        updatedCertificate.accounts = [...updatedCertificate.accounts];
        updatedCertificate.accounts[showAccount] = {
            ...updatedCertificate.accounts[showAccount],
            jurisdictionList: updatedJurisdictionList,
        };

        setCertificate(updatedCertificate);
        setReloadJurisdictionNextMonthDue(false);
        setIsSavedResult(false);

        setUpdateTotalTaxValue(true);
    }, [jurisdictionsNextMonthApiResponse]);


    useEffect(() => {
        if (removeJurisdiction || autoCalculate || clearJurisRow || reloadJurisdictionSection) {
            setUpdatedAccountIndexList((prev: any) => [...prev, showAccount]);
            setIsSavedResult(false);

            setShowReloadJurisdictionSection(false);
        }


    }, [removeJurisdiction, clearJurisRow, autoCalculate, reloadJurisdictionSection]);

    useEffect(() => {
        const fetchTaxRates = async () => {
            if (!reloadJurisdictionList || !curAccount?.jurisdictionList) return;

            const ids: string[] = curAccount.jurisdictionList
                .filter((el: any) => el.jurisdictionId)
                .map((el: any) => el.jurisdictionId);

            setShowReloadJurisdictionSection(true);

            try {
                await taxRateList(ids);
            } catch (error) {
                console.error("Failed to fetch tax rates", error);
            } finally {
                setReloadJurisdictionList(false);
            }
        };

        fetchTaxRates();
    }, [reloadJurisdictionList, curAccount]);


    useEffect(() => {
        if (reloadJurisdictionNextMonthDue) {
            let list: any[] = [];
            curAccount?.jurisdictionList.forEach((el: any) => {
                if (el.jurisdictionId && el.baseDue !== "" && el.baseDue !== null && (el.nextMonthTaxDue === "" || el.nextMonthTaxDue === null)) {
                    let obj = {
                        "jurisdictionId": el.jurisdictionId,
                        "taxYear": el.taxYear,
                        "levyPeriod": el.levyPeriod,
                        "nextPeriodDueDate": el.nextPeriodDueDate,
                        "nextNextPeriodDueDate": el.nextNextPeriodDueDate,
                    }
                    list.push(obj);
                }
            });


            const hasSuite = certificate.suites?.length > 0;

            const formattedList = list.map((item) => ({
                ...item,
                asOfDate: item.asOfDate instanceof Date ? item.asOfDate.toISOString() : item.asOfDate,
            }));

            if (list.length > 0) {
                jurisdictionsNextMonthApi({
                    hasSuite: hasSuite,
                    jurisdictions: formattedList
                });
            } else {
                setReloadJurisdictionNextMonthDue(false);
                showToast("No data found to update!");
            }
        }
    }, [reloadJurisdictionNextMonthDue]);

    useEffect(() => {
        if (isTaxSummaryReset) {
            setCertificate((prev : any) => {
                const updatedAccounts = [...prev.accounts];
                updatedAccounts[showAccount] = {
                    ...updatedAccounts[showAccount],
                    summaryList: [
                        {
                            asOfDate: null,
                            collector: "",
                            taxYear: "",
                            baseTax: null,
                            baseTaxDue: null,
                            nextPeriodDue: null,
                            nextNextPeriodDue: null
                        }
                    ],
                    baseTaxTotal: 0.00,
                    baseDueTotal: 0.00,
                    currentMonthTotal: 0.00,
                    nextMonthTotal: 0.00
                };

                return {
                    ...prev,
                    accounts: updatedAccounts
                };
            });

            setIsTaxSummaryReset(false);
        }
    }, [isTaxSummaryReset]);


    return (
        <>
            <div className="col-lg-12 col-sm-12 border border-highlight-3">
                <div className="border border-surface-5 bg-highlight-5 py-2 text-center text-text-0 flex">
                    <b className="grow">
                        Taxing Jurisdictions
                    </b>
                    <i
                        title={"Calculate Next Month Due"}
                        className={
                            !jurisdictionsNextMonthApiResponse.isLoading
                                ? "fa fa-calendar-check ml-3 mt-1 mr-2"
                                : "fas fa-sync fa-spin ml-3 mt-1 mr-2"
                        }
                        onClick={(e) => {
                            if (editable) {
                                e.preventDefault();
                                setReloadJurisdictionNextMonthDue(true);
                            }
                        }}
                    />
                    <i
                        title={"Load Tax Rate"}
                        className={
                            !reloadJurisdictionList
                                ? "fa fa-refresh ml-3 mt-1 mr-2"
                                : "fas fa-sync fa-spin ml-3 mt-1 mr-2"
                        }
                        onClick={(e) => {
                            if (editable) {
                                e.preventDefault();
                                setReloadJurisdictionList(true);
                            }
                        }}
                    />
                </div>
                <div className={'overflow-auto'}>
                    <table className={'w-full'}>
                        {NationalJurisdictionHeader(certificate,setCertificate, setShowJurisdictionPickerModal, editable, setIsSavedResult,setRender, showAccount, updatedAccountIndexList, setUpdatedAccountIndexList)}
                        <tbody>
                        {curAccount?.jurisdictionList?.map((row: any, p: number) => {
                            if (row) {
                                return (
                                    <tr key={p}>
                                        <td className="text-center">
                                            <i
                                                onClick={() => {
                                                    if (editable) {
                                                        setJurisdictionId(p);
                                                        setRemoveJurisdiction(true);
                                                    }

                                                }}
                                                className="fa fa-icon-color text-highlight-5 fa-trash onHover mt-2"
                                                id={p.toString()}
                                                title={"Delete Jurisdiction"}
                                            />
                                        </td>
                                        <td className="position-relative min-w-[190px]">
                                            <div className="relative bg-text-0">
        <span
            title={row["jurisdictionName"]}
            className="form-control text-center"
        >
            {row["jurisdictionName"] || "Select Juris ..."}
        </span>

                                                {!row["jurisdictionId"] && !row["jurisdictionName"] && (
                                                    <span
                                                        className="fa fa-search ml-xl-n4 collector-account-modal absolute right-[10px] top-[12px] text-highlight-0"
                                                        onClick={() => {
                                                            if (editable) {
                                                                setJurisdictionId(p);
                                                                setType("jurisdiction");
                                                                setShowAccount(showAccount);
                                                                setShowJurisdictionModal(true);
                                                                calculateAsOfDate(row);
                                                                setAutoCalculate(true);
                                                            }
                                                        }}
                                                    />
                                                )}
                                                {row["jurisdictionId"] && row["jurisdictionName"] && (
                                                    <span
                                                        className="fa fa-times ml-xl-n4 center_span_icon absolute right-[10px] top-[12px] text-highlight-0"
                                                        onClick={() => {
                                                            if (editable) {
                                                                setClearJurisRow(true);
                                                                setIsSavedResult(false);
                                                                calculateAsOfDate(row);
                                                                setJurisdictionId(p);
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </td>
                                        <td className="text-center min-w-[190px]">
                                            {nationalJurisdictionYearFields(
                                                row,
                                                setJurisdictionId,
                                                p,
                                                curAccount,
                                                setAccounts,
                                                accounts,
                                                setUpdateTotalTaxValue,
                                                setTaxYear,
                                                setIsAddNewSummaryRow,
                                                "taxYear",
                                                row.jurisdictionName === "" ||
                                                row.collectorName === "" ||
                                                row.jurisdictionName === null ||
                                                row.collectorName === null,
                                                setIsSavedResult,
                                                editable,
                                                setAutoCalculate
                                            )}
                                        </td>
                                        <td className="text-center min-w-[190px]">
                                            {nationalSelectDropdownField(
                                                row,
                                                "levyPeriod",
                                                (row.jurisdictionName === '' || row.collectorName === '' || row.jurisdictionName === null || row.collectorName === null),
                                                setIsSavedResult,
                                                setCertificate,
                                                enums?.["LevyPeriod"] || [],
                                                editable,
                                                showAccount,
                                                setUpdatedAccountIndexList,
                                                setAutoCalculate
                                            )}
                                            {/*{selectDropDownField(row, 'levyPeriod', (row['jurisdictionName'] === '' || row['collectorName'] === '' || row['jurisdictionName'] === null || row['collectorName'] === null), setIsSavedResult, accounts, setAccounts, levyPeriodEnums, editable, curAccount, showAccount, updatedAccountIndexList, setAutoCalculate)}*/}
                                        </td>
                                        <td className="text-center min-w-[190px]">
                                            <DateInputField
                                                row={row}
                                                name='dueDate'
                                                disabled={(row.jurisdictionName === '' || row.collectorName === '' || row.jurisdictionName === null || row.collectorName === null)}
                                                setIsSavedResult={setIsSavedResult}
                                                certificate={certificate}
                                                setCertificate={setCertificate}
                                                editable={editable}
                                                showAccount={showAccount}
                                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                                updatedAccountIndexList={updatedAccountIndexList}
                                            />
                                        </td>

                                        <td className="text-center min-w-[190px]">
                                            {jurisdictionRowFormatting(row,
                                                setAccounts,
                                                setJurisdictionId,
                                                p,
                                                setAutoCalculate,
                                                accounts,
                                                showAccount,
                                                'baseTax',
                                                editable,
                                                setIsSavedResult,
                                                curAccount,
                                                setUpdateTotalTaxValue,
                                                setIsAddNewSummaryRow,
                                                setTaxYear
                                            )}


                                        </td>
                                        <td className="text-center min-w-[190px]">
                                            {jurisdictionRowFormatting(
                                                row,
                                                setAccounts,
                                                setJurisdictionId,
                                                p,
                                                setAutoCalculate,
                                                accounts,
                                                showAccount,
                                                "baseDue",
                                                editable,
                                                setIsSavedResult,
                                                curAccount,
                                                setUpdateTotalTaxValue,
                                                setIsAddNewSummaryRow,
                                                setTaxYear
                                            )}
                                        </td>
                                        <td className="text-center min-w-[190px]">
                                            {nationalSelectDropdownField(
                                                row,
                                                "status",
                                                (row.jurisdictionName === '' || row.collectorName === '' || row.jurisdictionName === null || row.collectorName === null),
                                                setIsSavedResult,
                                                setCertificate,
                                                enums?.["LevyStatus"] || [],
                                                editable,
                                                showAccount,
                                                setUpdatedAccountIndexList,
                                                setAutoCalculate
                                            )}
                                        </td>
                                        <td className="text-center min-w-[190px]">
                                            <DateInputField
                                                row={row}
                                                name='paidDate'
                                                disabled={(row['jurisdictionName'] === '' || row['collectorName'] === '' || row['jurisdictionName'] === null || row['collectorName'] === null)}
                                                setIsSavedResult={setIsSavedResult}
                                                certificate={certificate}
                                                setCertificate={setCertificate}
                                                editable={editable}
                                                showAccount={showAccount}
                                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                                updatedAccountIndexList={updatedAccountIndexList}
                                            />
                                        </td>

                                        <td className="text-center min-w-[190px]">
                                            {jurisdictionRowFormatting(
                                                row,
                                                setAccounts,
                                                setJurisdictionId,
                                                p,
                                                setAutoCalculate,
                                                accounts,
                                                showAccount,
                                                "nextPeriodDue",
                                                editable,
                                                setIsSavedResult,
                                                curAccount,
                                                null,
                                                setIsAddNewSummaryRow,
                                                setTaxYear
                                            )}
                                        </td>
                                        <td className="text-center min-w-[190px]">
                                            {jurisdictionRowFormatting(
                                                row,
                                                setAccounts,
                                                setJurisdictionId,
                                                p,
                                                setAutoCalculate,
                                                accounts,
                                                showAccount,
                                                "nextNextPeriodDue",
                                                editable,
                                                setIsSavedResult,
                                                curAccount,
                                                null,
                                                setIsAddNewSummaryRow,
                                                setTaxYear
                                            )}
                                        </td>


                                    </tr>
                                );
                            }
                            return null;
                        })}
                        </tbody>
                    </table>
                </div>
                {showJurisdictionModal &&
                    <NationalJurisdictionListModal show={showJurisdictionModal}
                                                   setShow={setShowJurisdictionModal}
                                                   index={jurisdictionId}
                                                   certificate={certificate}
                                                   setCertificate={setCertificate}
                                                   setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                                   showAccount={showAccount}
                                                   type={type} county={county} orderId={orderId}
                                                   setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                                   setIsSavedResult={setIsSavedResult}
                    />
                }

                {showJurisdictionPickerModal &&
                    <NationalJurisdictionPickerModal show={showJurisdictionPickerModal}
                                                     setShow={setShowJurisdictionPickerModal}
                                                     certificate={certificate}
                                                     setCertificate={setCertificate}
                                                     showAccount={showAccount}
                                                     county={county}
                                                     setIsSavedResult={setIsSavedResult}
                                                     orderId={orderId}
                                             setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                             setRender={setRender}
                                             primaryCollector={primaryCollector}
                    />
                }
            </div>
        </>
    )
}
